import styled from 'styled-components';

export default styled.div`
	display: flex;
	flex-direction: column;
	padding: var(--content-v-pad) var(--content-h-pad);
	gap: var(--content-v-pad);
	min-height: 100%;
	.last-refreshed {
		justify-content: end;
	}
	.insight-select-filter {
		max-width: var(--px-300);
	}
`;
